(() => {
  const activate = (root) => {
    if (!(root instanceof Element)) return;
    const id = root.dataset.cvYoutubeId;
    if (!id || root.dataset.cvYoutubeLoaded === 'true') return;

    root.dataset.cvYoutubeLoaded = 'true';
    const title = root.dataset.cvYoutubeTitle || 'YouTube video';
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1`;
    iframe.title = title;
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    root.replaceChildren(iframe);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cv-youtube-lite__button');
    if (!button) return;
    event.preventDefault();
    activate(button.closest('.cv-youtube-lite'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const button = event.target.closest('.cv-youtube-lite__button');
    if (!button) return;
    event.preventDefault();
    activate(button.closest('.cv-youtube-lite'));
  });
})();
